import React from "react";
import FieldRenderer from "./FieldRenderer";
import { Typography, Divider } from "antd";

const { Title } = Typography;

export default function ProductInformation({
  fields,
  categoryId,
  allCategoryData,
  form,
  sizeUnits,
  setSizeUnits,
}) {
  return (
    <div id="product">
      <Title level={5} style={{ fontSize: 16, marginBottom: "2vh" }}>
        2. Product Info
      </Title>
      <FieldRenderer
        fields={fields}
        categoryId={categoryId}
        allCategoryData={allCategoryData}
        form={form}
        sizeUnits={sizeUnits}
        setSizeUnits={setSizeUnits}
      />
      <Divider />
    </div>
  );
}
